var map = {
	"./comodo-secure.png": 1045,
	"./flag-france.png": 1046,
	"./flag-germany.png": 1047,
	"./flag-italy.png": 1048,
	"./flag-netherlands.png": 1049,
	"./flag-portugal.png": 1050,
	"./flag-spain.png": 1051,
	"./flag-usa.png": 1052,
	"./global-cart-seal.png": 1053,
	"./icon-wanelo copy.png": 1054,
	"./icon-wanelo.png": 1055,
	"./icon-whatsapp copy.png": 1056,
	"./icon-whatsapp.png": 1057,
	"./lock.png": 1058,
	"./pagamento-cinza.png": 1059,
	"./pagamento-verde.png": 1060,
	"./pagamento-vermelho.png": 1061,
	"./payment-methods-br.png": 1062,
	"./payment-methods-global.png": 1063,
	"./payment-methods.png": 1064,
	"./pedido-cinza.png": 1065,
	"./pedido-verde.png": 1066,
	"./pedido-vermelho.png": 1067,
	"./selo-ebit-ouro.png": 1068,
	"./selo-eureciclo.png": 1069,
	"./selo-internet-segura.png": 1070,
	"./selo-ra1000.png": 1071,
	"./selo_100-seguro-retina.png": 207,
	"./selo_100-seguro.png": 1072,
	"./selo_site_seguro_certisign.png": 1073,
	"./selo_site_seguro_mcafee.png": 1074,
	"./selo_site_seguro_norton.png": 1075,
	"./selo_site_seguro_norton_small.png": 1076,
	"./separacao-cinza.png": 1077,
	"./separacao-verde.png": 1078,
	"./separacao-vermelho.png": 1079,
	"./shipping-methods-global.png": 1080,
	"./transporte-cinza.png": 1081,
	"./transporte-verde.png": 1082,
	"./transporte-vermelho.png": 1083
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1044;